export default "__VITE_ASSET__916ae036__"